import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface ChgDataLogIntervalState {
    SelectedReefers: any[];
    SelectedInterval: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    renderDropDown: any;
    VCCheckBoxInfo: VCCheckBoxData;  
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class ChangeDataLogInterval extends React.Component<any, ChgDataLogIntervalState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], SelectedInterval: "60", RowData: [], Filters: filterSet, renderDropDown: '', VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };        
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData, renderDropDown: this.renderDropDownInterval(this.props.reeferData[0]) });
            this.renderChangeDatalogIntervalGrid(this.props.reeferData); 
        } 
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

        $('#globalLoader').hide();
    }

    renderDropDownInterval(rowData: server.USP_UnitCurrentConditionUI_Model) {
        if (rowData.ReeferOEMTypeCd.trim() == 'S') {
            return <select id='ddlInterval' className='form-select' onChange={e => this.DataLogIntervalchange(e)}>
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="45">45</option>
                <option value="60" selected>60</option>
                <option value="75">75</option>
                <option value="90">90</option>
                <option value="105">105</option>
                <option value="120">120</option>
                <option value="135">135</option>
                <option value="150">150</option>
                <option value="165">165</option>
                <option value="180">180</option>
                <option value="195">195</option>
                <option value="210">210</option>
                <option value="225">225</option>
                <option value="240">240</option>
            </select>;
        }
        else {
            return <select id='ddlInterval' className='form-select' onChange={e => this.DataLogIntervalchange(e)}>
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="60" selected>60</option>
                <option value="120">120</option>
            </select>;
        }
    }

    submitDataLogInterval() {
        var selectedInterval = parseInt(this.state.SelectedInterval);
        if (selectedInterval >= 1) {
            var command = "SetDatalogInterval";
            var paramValue = this.state.SelectedInterval;
            var refreshGrid = this.props.refreshGrid;
            ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        } else { PopupWindow.showErrorMessage("Change Datalog Interval", "Please select valid Datalog Interval."); }
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.setState({ renderDropDown: this.renderDropDownInterval(reeferData[0]) });
            this.renderChangeDatalogIntervalGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderChangeDatalogIntervalGrid(reeferData: any) {
        this.state.Filters.CommandName = "SetDatalogInterval";
        this.state.Filters.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData });
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    DataLogIntervalchange(event: React.FormEvent<HTMLSelectElement>) {
        var selectedInterval = this.state.SelectedInterval;
        var Value: string = event.currentTarget.value;
        selectedInterval = Value.toString();
        this.setState({ SelectedInterval: selectedInterval });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "SetDatalogInterval", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div className="modal-controls-container">
                <div className='row'>
                    <div className='col-lg-5 col-md-6 col-sm-6 col-xs-6 text-start text-sm-end pe-0'>
                        <label className='col-form-labelt'>Set DataLog Interval (In Minutes) :</label>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'>
                        { this.state.renderDropDown }
                    </div>
                </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"SetDatalogInterval"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitDataLogInterval.bind(this)}>Save</button>
                
            </div>
        </div>
    }
}